import { OrderUploadingTexts, OrderUploadingTypes } from './order-uploading.types';
import { getDateString } from '../../../utils/convert-UTC-date-to-local-date';
import { DOCUMENT_TYPES, VEHICLE_OFFER_EVENT_DESCRIPTIONS } from '../../../constants';

export const MAX_FILE_SIZE = 10485760;

export const ORDER_UPLOADING_DATA: OrderUploadingTexts = {
  [OrderUploadingTypes.UnsignedOrder]: {
    infoHint:
      'Bitte lade die Bestellung hoch. Nach dem Hochladen kann der Kunde sie herunterladen, unterschreiben und erneut hochladen.',
    uploadingComponentLabel: 'Bestellung (zum Unterschreiben)',
    uploadedDate: (date?: string | null) =>
      `Die Bestellung zum Unterschreiben wurde bereits am ${getDateString(date)} hochgeladen.`,
    documentType: DOCUMENT_TYPES.unsignedOrder,
    eventDescription: VEHICLE_OFFER_EVENT_DESCRIPTIONS.receiveDealerDocuments,
    noNeedToSignEventDescription: VEHICLE_OFFER_EVENT_DESCRIPTIONS.requestedLeasingDocuments,
    actualizeFileEventDescription: VEHICLE_OFFER_EVENT_DESCRIPTIONS.actualizeReceiveDealerDocuments
  },
  [OrderUploadingTypes.UnsignedLeasingContract]: {
    infoHint:
      'Bitte lade den Leasingvertrag hoch. Nach dem Hochladen kann der Kunde diesen herunterladen, unterschreiben und erneut hochladen.',
    uploadingComponentLabel: 'Leasingvertrag (zum Unterschreiben)',
    uploadedDate: (date?: string | null) =>
      `Die Leasingvertrag zum Unterschreiben wurde bereits am ${getDateString(date)} hochgeladen.`,
    documentType: DOCUMENT_TYPES.unsignedLeasingContract,
    eventDescription: VEHICLE_OFFER_EVENT_DESCRIPTIONS.receiveLeasingDocuments,
    noNeedToSignEventDescription: VEHICLE_OFFER_EVENT_DESCRIPTIONS.orderCompleted,
    actualizeFileEventDescription: VEHICLE_OFFER_EVENT_DESCRIPTIONS.actualizeReceiveLeasingDocuments
  },
  [OrderUploadingTypes.SignedOrder]: {
    infoHint:
      'Bitte lade die unterschriebene Bestellung hoch. Nach dem Hochladen steht diese dem Autohaus und ggfs. der Leasinggesellschaft zur Verfügung.',
    uploadingComponentLabel: 'Unterschriebene Bestellung',
    uploadedDate: (date?: string | null) =>
      `Die unterschriebene Bestellung wurde bereits am ${getDateString(date)} hochgeladen.`,
    documentType: DOCUMENT_TYPES.signedOrder,
    eventDescription: VEHICLE_OFFER_EVENT_DESCRIPTIONS.requestedLeasingDocuments,
    actualizeFileEventDescription: VEHICLE_OFFER_EVENT_DESCRIPTIONS.requestedLeasingDocuments
  },
  [OrderUploadingTypes.SignedLeasingContract]: {
    infoHint:
      'Bitte lade den unterschriebenen Leasingvertrag hoch. Dieser steht direkt nach dem Hochladen der Leasingbank zur Verfügung.',
    uploadingComponentLabel: 'Unterschriebener Leasingvertrag',
    uploadedDate: (date?: string | null) =>
      `Die unterschriebene Leasingvertrag wurde bereits am ${getDateString(date)} hochgeladen.`,
    documentType: DOCUMENT_TYPES.signedLeasingContract,
    eventDescription: VEHICLE_OFFER_EVENT_DESCRIPTIONS.orderCompleted,
    actualizeFileEventDescription: VEHICLE_OFFER_EVENT_DESCRIPTIONS.orderCompleted
  }
};
